<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_budgets_count"
				:loading-info="loadingList"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_budgets"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_budgets_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
      <template v-slot:item.code="{ item }">
				<p class="caption mb-0">
					<b class="text-end" style="flex: 1;">{{ item.serial?.serial }} - LP{{ item.morphable?.project_line_info?.project_line?.number }} - {{ item.prefix?.prefix }} {{ item.info?.budget_prefix_index }}</b>
				</p>
      </template>
      <template v-slot:item.company="{ item }">
				<div class="text-start">
					<p class="mb-0 caption"><b>Empresa:</b> {{ item.morphable?.company.name }}</p>
					<p class="caption mb-0"><b>Proyecto:</b> {{ item.morphable?.name || item.morphable?.info?.project_detail || '--' }}</p>
					<p class="caption mb-0"><b>Dirección:</b> {{item.morphable?.info?.address?.address ?? '--'}} {{item.morphable?.info?.address?.district?.name ?? '--'}}</p>
				</div>
      </template>
			<template v-slot:item.name="{ item }">
				<div>
					<p class="caption mb-0">{{item.morphable?.name ?? '--'}}</p>
				</div>
			</template>
			<template v-slot:item.address="{ item }">
				<div>
					<p class="caption mb-0">{{item.morphable?.info?.address?.address ?? '--'}}</p>
					<p class="caption mb-0">{{item.morphable?.info?.address?.district?.name ?? '--'}}</p>
				</div>
			</template>
			<template v-slot:item.budget_date="{ item }">
				<div>
					<p class="caption mb-0">{{item.created_at | toDate}}</p>
				</div>
			</template>
      <template v-slot:item.status="{ item }">
				<div>
					<p class="caption mb-0"><small>Creado: <b>{{item.created_at | toDate}}</b></small></p>
					<v-chip
						:color="item.last_status?.status | budgetStatusColor"
						label
						outlined
						x-small
						class="px-1"
					>
						<b>{{ item.last_status?.status | budgetStatus }}</b>
					</v-chip>
					<p class="ml-2 mb-0 caption">{{ item.last_status?.description }}</p>
				</div>
			</template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							@click.stop="() => { selectRow(item); openBudgetDetail(item.id); }"

							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-book-cog-outline</v-icon>
						</v-btn>
					</template>
					<span>Ver Presupuesto</span>
				</v-tooltip>
      </template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_budgets_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
// import moment from 'moment'
import _debounce from 'lodash/debounce'
import {getClientBudgets} from '@/helpers/api/clients'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientsBudgetList',
	components: {
		DataTablePagination
	},
	props: {
		clientId: {
      type: Number,
      required: true
    },
		openBudgetDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		selected_budget() {
			return this.$route.query?.b
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientBudgets()
      },
      deep: true,
    }
	},
	data: () => ({
		selectedRowItem: null,
		loadingList: true,
		client_budgets: [],
		client_budgets_count: 0,
		headers: [
			{ text: 'Nº', value: 'code', align: 'start', sortable: false },
			{ text: 'Detalle', value: 'company', align: 'start', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', width: 140, sortable: false },
			{ text: 'Acciones', value: 'actions', align: 'center', width: 140, sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientBudgets()
		const budget_id = this.$route.query.b
		if(budget_id){
			this.selectedRowItem = budget_id
			this.openBudgetDetail(budget_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_budgets_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		eventBus.$on('reloadInformation', this._onReloadContract)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this._onReloadContract);
	},
	methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_budgets_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientBudgets()
		},
		_onReloadContract(){
			this.getClientBudgets()
		},
		getRowClass(item) {
			return item.id == this.selected_budget ? 'custom-client-highlight-row client-row-budget' : 'client-row-budget';
		},
		async getClientBudgets(){
			this.loadingList = true
			try {
				let data = {
					...this.options,
					client_id: this.clientId,
					start: (this.options.page - 1) * this.options.itemsPerPage,
					limit: this.options.itemsPerPage,
				}
				if(this.searchInput){
					data = {...data, ...{search: this.searchInput}}
				}
				const client_budget = await getClientBudgets(data)
				if(client_budget.code == 200){
					this.client_budgets = client_budget.client_budgets
					this.client_budgets_count = client_budget.client_budgets_count
				}
			} catch (error) {
				console.log(error)
			}
			this.loadingList = false
		},
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
.client-row-budget{
	cursor: pointer;
}
</style>